import React from 'react';
import { useSelector } from 'react-redux';
import { getReturnedItems } from '../../../selectors/tools';
import DTSendMacroAndRefundItemsNode from '../NodeGroups/DTCopyTextSendMacro/DTSendMacroAndRefundItemsNode/DTSendMacroAndRefundItemsNode';

const SendMacroAndRefundItems = () => {
  const returnedItems = useSelector(getReturnedItems);
  const returnedItemsAreRefunded = returnedItems.some(
    (item) => item && item.qty_refunded && parseFloat(item.qty_refunded) > 0
  );

  return (
    <DTSendMacroAndRefundItemsNode
      showConfirmation={returnedItems && returnedItemsAreRefunded}
      message={'The items have been refunded.'}
    />
  );
};

export default SendMacroAndRefundItems;
